module.exports = "/1/10-do-uu-tien-cua-cac-toan-tu/index.html.7a47c8f2c1a6101a3700bbc2c0ee315e.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/29574.md
 ** module id = 530
 ** module chunks = 0
 **/